import React from "react";

export default function WhyPartner() {
    return (
        <>
            <section className="pt-20 pb-20">
                <div className="container px-1">
                    <img src="/why_partner.jpeg" alt="Tarif Overseas Headquarters" className="img-fluid" />
                </div>
            </section>
        </>
    );
}